import { render, staticRenderFns } from "./PlayerLastSession.vue?vue&type=template&id=7b26d627&"
import script from "./PlayerLastSession.vue?vue&type=script&lang=js&"
export * from "./PlayerLastSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports